export function downloadBlob(blob: Blob, filename: string, revokeDelayMs = 1_000): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  try {
    link.href = url;
    link.download = filename;
    link.rel = "noopener";
    document.body.appendChild(link);
    link.click();
  } finally {
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), Math.max(0, revokeDelayMs));
  }
}
